(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-cart-bar')) {
    customElements.define(
      'cp-cart-bar',
      class CpCartBar extends HTMLElement {
        connectedCallback() {
          this.product = this.closest('product-component');
          if (!this.product) return;

          this.selects = Array.from(this.querySelectorAll('[data-cp-bar-option]'));
          this.image = this.querySelector('.cp-bar__image img');
          this.text = this.querySelector('[data-cp-bar-text]');
          this.button = this.querySelector('[data-add-to-cart-bar]');
          this.mainButton = this.product.querySelector('[data-product-form] [data-add-to-cart]');

          try {
            this.productJson = JSON.parse(this.product.querySelector('[data-product-json]').textContent);
          } catch (error) {
            this.productJson = null;
          }

          this.selects.forEach((select) => select.addEventListener('change', () => this.selectOnPage(select)));
          this.product.addEventListener('change', (event) => {
            if (!this.contains(event.target)) window.requestAnimationFrame(() => this.syncFromPage());
          });

          // Follow the page's add to cart button (variant available / sold out)
          if (this.mainButton) {
            new MutationObserver(() => this.syncButton()).observe(this.mainButton, {attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true});
          }

          this.syncFromPage();
        }

        // Selecting in the bar clicks the matching option input of the page's variant picker
        selectOnPage(select) {
          const index = `option${select.dataset.cpBarOption}`;
          const inputs = Array.from(this.product.querySelectorAll(`[data-product-variants] [data-index="${index}"]`)).filter((input) => !this.contains(input));
          const input = inputs.find((item) => item.value === select.value);

          if (input && input.type === 'radio') {
            input.click();
          } else if (input) {
            const option = this.product.querySelector(`[data-product-variants] [data-popout-option][data-value="${CSS.escape(select.value)}"]`);
            option?.click();
          }

          window.requestAnimationFrame(() => this.syncFromPage());
        }

        selections() {
          return this.selects.map((select) => {
            const index = `option${select.dataset.cpBarOption}`;
            const checked = this.product.querySelector(`[data-product-variants] input[data-index="${index}"]:checked`);
            const hidden = this.product.querySelector(`[data-product-variants] input[data-popout-input][data-index="${index}"]`);
            return checked ? checked.value : hidden ? hidden.value : select.value;
          });
        }

        syncFromPage() {
          const values = this.selections();
          this.selects.forEach((select, position) => {
            if (values[position] && select.value !== values[position]) select.value = values[position];
          });

          const variant = this.productJson?.variants?.find((item) => item.options.every((value, position) => value === values[position]));
          const src = variant?.featured_image?.src;
          if (this.image && src) {
            const url = src.replace(/^https?:/, '');
            const sized = url + (url.includes('?') ? '&' : '?') + 'width=160';
            if (this.image.getAttribute('src') !== sized) {
              this.image.removeAttribute('srcset');
              this.image.src = sized;
            }
          }

          this.syncButton();
        }

        syncButton() {
          if (!this.mainButton || !this.button) return;

          const disabled = this.mainButton.hasAttribute('disabled');
          this.button.toggleAttribute('disabled', disabled);

          const mainText = this.mainButton.querySelector('[data-add-to-cart-text]')?.textContent.trim();
          if (this.text && mainText && this.text.textContent.trim() !== mainText) this.text.textContent = mainText;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-conversion-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const month = new Intl.DateTimeFormat('es-ES', {month: 'short'});
    const normalizeMonth = (date) => month.format(date).replace('.', '');
    document.querySelectorAll('[data-cp-stock]').forEach((element) => {
      const stock = Math.floor(Math.random() * 7) + 2;
      const number = element.querySelector('[data-cp-stock-number]');
      const bar = element.querySelector('[data-cp-stock-bar]');
      if (number) number.textContent = stock;
      if (bar) bar.style.width = `${32 + stock * 6}%`;
    });
    document.querySelectorAll('[data-cp-delivery-date]').forEach((element) => {
      const first = new Date();
      const second = new Date();
      first.setDate(first.getDate() + 1);
      second.setDate(second.getDate() + 2);
      if (first.getMonth() === second.getMonth()) {
        element.textContent = `${first.getDate()}–${second.getDate()} ${normalizeMonth(second)}`;
      } else {
        element.textContent = `${first.getDate()} ${normalizeMonth(first)}–${second.getDate()} ${normalizeMonth(second)}`;
      }
    });
    document.querySelectorAll('.radio__legend__option-name').forEach((element) => {
      const label = element.textContent.trim().toLocaleLowerCase('it-IT');
      if (label === 'colore del metallo' || label === 'colore') element.textContent = 'Color del metal';
      if (label === 'misura' || label === 'taglia') element.textContent = 'Talla';
    });
    document.querySelectorAll('[data-cp-savings]').forEach((element) => {
      const priceWrap = element.closest('[data-price-wrapper]');
      const price = priceWrap?.querySelector('[data-product-price]');
      const compare = priceWrap?.querySelector('[data-compare-price]');
      const amount = element.querySelector('[data-cp-savings-amount]');
      const readCents = (node) => {
        const value = (node?.textContent || '').replace(/[^0-9.,]/g, '');
        const decimal = value.match(/[.,](\d{1,2})$/);
        if (!decimal) return Number(value.replace(/[^0-9]/g, '')) * 100;
        const whole = value.slice(0, decimal.index).replace(/[^0-9]/g, '');
        return Number(whole || 0) * 100 + Number(decimal[1].padEnd(2, '0'));
      };
      const updateSavings = () => {
        const compareCents = readCents(compare);
        const difference = compareCents - readCents(price);
        element.hidden = difference <= 0;
        if (amount && difference > 0) {
          const value = window.theme.formatMoney(difference, window.theme.moneyWithoutCurrencyFormat);
          if (amount.innerHTML !== value) amount.innerHTML = value;
        }
      };
      updateSavings();
      const observer = new MutationObserver(() => window.requestAnimationFrame(updateSavings));
      if (price) observer.observe(price, {childList: true, characterData: true, subtree: true});
      if (compare) observer.observe(compare, {childList: true, characterData: true, subtree: true});
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
